import { Truck, RotateCcw, Ban, FileText } from "lucide-react";
import { PageHero } from "../../components/sections";
import { StoreToTrainingBand } from "../../store/components";

const POLICIES = [
  {
    icon: Truck,
    title: "Shipping Policy",
    points: [
      "Orders are processed after confirmation by the DWC Store team.",
      "Estimated delivery timelines are shown at checkout and will be finalised once supplier logistics are confirmed.",
      "Shipping charges and free-shipping thresholds are shown clearly in your cart before you place the order.",
      "Delivery timelines may vary by location and product availability.",
    ],
  },
  {
    icon: RotateCcw,
    title: "Return & Refund Policy",
    points: [
      "Return eligibility and return windows are product-specific and follow the supplier's return rules, which will be confirmed at the time of order confirmation.",
      "Products must be unused and in original packaging to be eligible for return.",
      "Approved refunds are processed to the original payment method.",
      "For any return or refund request, contact the DWC Store team on WhatsApp or phone with your order number.",
    ],
  },
  {
    icon: Ban,
    title: "Cancellation Policy",
    points: [
      "Orders can be cancelled before they are shipped by contacting the DWC Store team with your order number.",
      "Once an order is shipped, the return policy applies instead of cancellation.",
      "For prepaid orders cancelled before shipping, the refund is processed to the original payment method.",
    ],
  },
  {
    icon: FileText,
    title: "Store Terms",
    points: [
      "DWC Store is the e-commerce section of Drive With Confidence — Mumbai, Surat & Ahmedabad.",
      "Product descriptions reflect manufacturer/supplier information. Actual product claims always follow the supplier's specifications.",
      "Prices and availability may change without notice. The price at the time of order placement applies.",
      "These store policies are separate from DWC's driving-training terms and guarantee terms.",
    ],
  },
];

const StorePolicies = () => (
  <>
    <PageHero
      eyebrow="DWC Store"
      lines={["Store Policies."]}
      text="Shipping, returns, refunds, cancellation and store terms for DWC Store orders."
    />
    <section className="bg-white py-20 md:py-24" data-testid="store-policies-page">
      <div className="mx-auto grid max-w-5xl gap-6 px-5 md:grid-cols-2 lg:px-8">
        {POLICIES.map((p) => (
          <article key={p.title} className="rounded-2xl border border-gray-100 bg-white p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
            <p.icon className="h-6 w-6 text-dwc-green" aria-hidden="true" />
            <h2 className="mt-3 text-lg font-extrabold tracking-tight text-dwc-charcoal">{p.title}</h2>
            <ul className="mt-3 space-y-2 text-sm leading-relaxed text-dwc-charcoal/70">
              {p.points.map((pt) => (
                <li key={pt} className="flex gap-2"><span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-dwc-crimson" aria-hidden="true" />{pt}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
      <p className="mx-auto mt-10 max-w-5xl px-5 text-center text-xs text-dwc-charcoal/45 lg:px-8" data-testid="policies-note">
        Note: Specific return windows and delivery timelines will be finalised and updated here once supplier partnerships are confirmed by the DWC team.
      </p>
    </section>
    <StoreToTrainingBand />
  </>
);

export default StorePolicies;
